import focusLock from 'dom-focus-lock';
import { setScrollbarWidthOnDocument } from '../../functions/setScrollbarWidthOnDocument';
import { toggleAriaHiddenOnBodyChildren } from '../../functions/toggleAriaHiddenOnBodyChildren';
import { noPreferenceReducedMotion } from '../../functions/reducedMotion';
export default function toggleMenu(menuSelector, buttonSelector, headerSelector, close) {
    const menu = document.querySelector(menuSelector);
    const menuButton = document.querySelector(buttonSelector);
    const header = document.querySelector(headerSelector);
    const shellHeader = document.querySelector('#spv-shell-header');
    const allMenus = Array.from(document.querySelectorAll(menuSelector));
    if (!menu || !menuButton || !header)
        return;
    const menuItems = Array.from(menu.querySelectorAll('li'));
    function closeAllMenus() {
        allMenus.forEach((menu) => {
            if (menu?.classList.contains('spv-header__menu--isOpen')) {
                closeNavigation();
            }
        });
    }
    function closeNavigation() {
        menu?.classList.remove('spv-header__menu--isOpen');
        header?.classList.remove('spv-header--menuIsOpen');
        menuButton?.setAttribute('aria-expanded', 'false');
        window.removeEventListener('keyup', escapeEvent);
        toggleAriaHiddenOnBodyChildren(shellHeader, 'off');
        setScrollbarWidthOnDocument();
        if (!close) {
            focusLock.off(header);
            document.documentElement.classList.remove('spv-scrollLock');
            menuButton?.focus();
        }
    }
    function openNavigation() {
        closeAllMenus();
        setScrollbarWidthOnDocument();
        document.documentElement.classList.add('spv-scrollLock');
        menu?.classList.add('spv-header__menu--isOpen');
        header?.classList.add('spv-header--menuIsOpen');
        menuButton?.setAttribute('aria-expanded', 'true');
        window.addEventListener('keyup', escapeEvent);
        toggleAriaHiddenOnBodyChildren(shellHeader, 'on');
        focusLock.on(header);
        if (noPreferenceReducedMotion) {
            import('gsap').then(({ gsap }) => {
                gsap.set(menuItems, { y: '-100%', opacity: 0 });
                gsap.to(menuItems, {
                    y: 0,
                    opacity: 1,
                    duration: 0.2,
                    stagger: 0.02,
                    ease: 'back.out',
                });
            });
        }
    }
    function escapeEvent(event) {
        if (event.defaultPrevented) {
            return;
        }
        const key = event.key || event.code;
        if (key === 'Escape' || key === 'Esc' || key === '27') {
            closeNavigation();
        }
    }
    if (menu?.classList.contains('spv-header__menu--isOpen') || close) {
        closeNavigation();
    }
    else {
        openNavigation();
    }
}
//# sourceMappingURL=toggleMenu.js.map